import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import { UpdatesSection, MediaSection, ContactSection, AboutSection } from './components/SectionsA';
import { FeaturesSection, CommentsSection, TopicsSection, RankingSection } from './components/SectionsB';
import { IndexSection, CarouselSection, AppSection, CardsSection, FAQSection } from './components/SectionsC';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <UpdatesSection />

        <MediaSection />

        <ContactSection />

        <AboutSection />

        <FeaturesSection />

        <CommentsSection />

        <TopicsSection />

        <RankingSection />

        <IndexSection />

        <CarouselSection />

        <AppSection />

        <CardsSection />

        <FAQSection />
      </main>

      <Footer />
    </div>
  );
}